import React, {
  createContext,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import axios, { AxiosInstance } from "axios";

import authHeader from "../services/AuthHeader";
import AuthService from "../services/AuthService";
import { API_URL, MAIN_HOST } from "../api";
import { loadStripe } from "@stripe/stripe-js";
import { get_stripe_customer_account_id } from "../API/index";

const DefaultProps = {
  login: () => null,
  logout: () => null,
  authAxios: axios,
  user: null,
  stripePromise: null,
};

export const AuthContext = createContext(DefaultProps);

export const AuthContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => AuthService.getCurrentUser());
  const [stripeAccount, setStripeAccount] = useState(null);

  async function login(email, password, company) {
    const data = await AuthService.login(email, password, company);
    setUser(data);
    return data;
  }

  function logout() {
    AuthService.logout();
    setUser(null);
    window.location.href = MAIN_HOST + "/login";
    // navigate('/login');
  }

  async function getStripeAccount() {
    const formData = new FormData();
    const res = await get_stripe_customer_account_id(formData);
    if (res.status === 200) {
      setStripeAccount(res.data.stripe_account_id);
    } else {
      console.log("Error getting stripe account");
    }
  }

  useEffect(() => {
    getStripeAccount();
  }, []);

  // axios instance for making requests
  const authAxios = axios.create();

  // request interceptor for adding token
  authAxios.interceptors.request.use((config) => {
    // add token to request headers
    config.headers = authHeader();
    config.baseURL = API_URL;
    return config;
  });

  authAxios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        // logout();
      }
      return Promise.reject(error);
    }
  );

  const stripePromise = useMemo(() => {
    if (!user) {
      return null;
    }

    const stripeKey =
      process.env.NODE_ENV === "development"
        ? "pk_test_51LXa59CslfodJUTgJzuTCNCbS6pmc12M1ozlD6wJLfx7lqfk6g1xCVwVRxgYdyPIX3SaKfQ4ozWJDOH0P1eRSwGg00Zw9lSAlJ"
        : "pk_live_51LXa59CslfodJUTgWc4eopGCF8oNmTMtS5SgmUfdlbeuA9kui2kFxiaSzIRkODJvbkJB24mgVsabciqbrSaiqd0800B8qTbjsO";

    if (!stripeAccount) {
      return loadStripe(stripeKey);
    } else {
      return loadStripe(stripeKey, {
        stripeAccount: stripeAccount,
      });
    }
  }, [stripeAccount]);

  return (
    <AuthContext.Provider
      value={{ user, login, logout, authAxios, stripePromise }}
    >
      {children}
    </AuthContext.Provider>
  );
};
